let records =   window.drupalSettings.ngaNews;
let items = Object.values(records);


let modifiedArr = items.map(function(element){
  return  {
    'title': element.title ,
    'categories': element.field_general_topic.toLowerCase().split(', '),
    'field_general_topic': element.field_general_topic,
    'view_node': element.view_node ,
    'nothing': element.nothing ,
    'created': element.created ,
    'body': element.body,
    'field_media_image': element.field_media_image,
    'news_topic': element.news_type
  }
});


// console.log(modifiedArr);

export default modifiedArr;
